import { Stack } from '@mui/material';
import { get, isArray } from 'lodash';
import React, { FC, ReactElement, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import MuiSnackbar from '../../../../components/ui-component/mui-snackbar/MuiSnackbar';
import MUIToolTip from '../../../../components/ui-component/mui-tooltip/MUIToolTip';
import { PostRecord } from '../../../../lib/api/PostRecord';
import { APIS } from '../../../../lib/constants/apis';
import { ANTRAG_VERBUNDPARTNER } from '../../../../lib/constants/componentsPath';
import { ANTRAG_BUTTON_NAME, ANTRAGS_STATUS, MITTEL_ABRUF_ZUERST_ERSTELLEN_TEXT, NOCH_NICHT_MOEGLICH_TEXT } from '../../../../lib/constants/constant';
import { PAGES_URLS } from '../../../../lib/constants/routes';
import { enumT } from '../../../../utils/helper';
import { AntragButton, AntragsButtonWrapper } from '../FoerderungUebersicht';

// Import Schema
import Schema from '../../../../lib/paths/antrag_FULL_Paths.json';
import KostenPostionSchema from '../../../../lib/paths/kostenposition_FULL_Paths.json';
import MittelabrufSchema from '../../../../lib/paths/mittelabruf_FULL_Paths.json';
import VerwendungsnachweisSchema from '../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const P = Schema.attributes;
const MA_P = MittelabrufSchema.attributes;
const VN_P = VerwendungsnachweisSchema.attributes;
const KP_P = KostenPostionSchema.attributes;

const EbusseFoerderDashboard: FC<{ application: any }> = ({ application }) => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [wsError, setWsError] = useState(false);

	const checkJahrCondition = false;
	const currentYear = new Date().getFullYear();

	const projektDauer = get(application, P.Allgemein_Projektdauerin_Jahren.path, 0);
	const projektJahrStart = get(application, P.Allgemein_Projektstart_Jahr.path);

	const mittelAbruf = get(application, P.Foerderantrag_Mittelabrufs.path, []);
	const verwendungsnachweis = get(application, P.Foerderantrag_Verwendungsnachweiss.path, []);
	const abschlussbericht = get(application, P.Foerderantrag_Abschlussberichts.path, []);

	const handleCreateMittelabruf = async (projektJahr: number) => {
		// autofold/fold_next
		const MA_Data = {
			Foerderantrag: get(application, 'id'),
			Mittelabrufstatus_Mittelabrufstatus: ANTRAGS_STATUS.inBearbeitung,
			Allgemein_Haushaltsjahr: projektJahr,
			Allgemein_Abrufdatum: new Date(),
			Bankverbindung_Bank: get(application, P.Antragstellende_Organisation_Bankverbindung_Geldinstitut.path),
			Bankverbindung_IBAN: get(application, P.Antragstellende_Organisation_Bankverbindung_IBAN.path),
			Bankverbindung_BIC: get(application, P.Antragstellende_Organisation_Bankverbindung_BIC.path),
			Ermittlung_Des_Auszahlungsbetrages_Bewilligte_Zuwendung: get(application, P.Bewilligung_Jahresaufteilung.path, []).find(
				(ele: any) => get(ele, 'Projektjahr', '') === projektJahr
			)?.Zuwendung,
			Ermittlung_Des_Auszahlun_0254424978_ngen_Im_Gleichen_Projektjahr: get(
				mittelAbruf[mittelAbruf.length - 1],
				MA_P.Ermittlung_Des_Auszahlungsbetrages_Bereits_Ausgezahlte_Mittel.path,
				0
			),
			Kalkulation_Block_1: [
				{
					Zelle_1: get(application, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, ''),
					Zelle_2: get(application, P.Antragstellende_Organisation_Foerderquote.path, []).find((ele: any) => get(ele, 'Projektjahr') === projektJahr)
						?.Foerderquote_403741,
				},
				...get(application, P.Verbundpartner.path, [])
					.filter((ele: any) => get(ele, ANTRAG_VERBUNDPARTNER.Name, '') !== '')
					.map((eachVP: any) => {
						return {
							Zelle_1: get(eachVP, ANTRAG_VERBUNDPARTNER.Name, ''),
							Zelle_2: get(eachVP, ANTRAG_VERBUNDPARTNER.FoerderQuoteBlock, []).find((ele: any) => get(ele, 'Projektjahr') === projektJahr)
								?.Foerderquote_403741,
						};
					}),
			],
		};
		try {
			setLoading(true);
			let res = await PostRecord(APIS.Mittelabruf, { data: MA_Data });
			if (res) {
				const allKostenPosition = get(application, P.Foerderantrag_Kostenpositions.path, []);
				const vnData = {
					Allgemein_Haushaltsjahr: projektJahr,
					Verwendungsnachweisstatus_Status: ANTRAGS_STATUS.inBearbeitung,
					Foerderantrag: get(application, 'id'),
					Mittelabruf: get(res, 'data.id'),
					Allgemein_Foerderquote_Antragstellerin: get(application, P.Orga_Foerderquote_Gesamt.path),
				};
				try {
					let vnRes = await PostRecord(APIS.Verwendungsnachweis, { data: vnData });
					if (vnRes) {
						for (let i = 0; i < allKostenPosition.length; i++) {
							const eachKP = allKostenPosition[i];
							const nachweisData = {
								Allgemein_Nr: i + 1,
								Allgemein_Kostentraeger: get(eachKP, KP_P.Allgemein_Kostentraeger.path),
								Allgemein_Unternehmen_Institution: get(eachKP, `${KP_P.Unternehmen.path}.id`),
								Verwendungsnachweis: get(vnRes, 'data.id'),
								Allgemein_Kostenposition: get(eachKP, 'id'),
								Allgemein_Kostenart: get(eachKP, KP_P.Allgemein_Kostenposition.path),
							};
							await PostRecord(APIS.Nachweisposition, { data: nachweisData });
						}
					}
				} catch (err: any) {
					console.error('ERROR: Creating Verwendungsnachweis ', err);
				} finally {
					navigate(PAGES_URLS.OnlineAntrag, { state: { id: get(res, 'data.id'), api: APIS.Mittelabruf } });
				}
			}
		} catch (err: any) {
			setWsError(true);
			console.error('ERROR: Creating Mittelabruf ', err);
		} finally {
			setLoading(false);
		}
	};
	const handleCreateAbschlussbericht = async () => {
		// autofold/fold_next
		let abBerichtData = {
			Foerderantrag: get(application, 'id'),
			Abschlussberichtstatus_Abschlussberichtsstatus: ANTRAGS_STATUS.inBearbeitung,
			Antragsteller: get(application, `${P.Antragstellende_Organisation.path}.id`),
		};

		try {
			setLoading(true);
			let res = await PostRecord(APIS.Abschlussbericht, { data: abBerichtData });
			if (res) navigate(PAGES_URLS.OnlineAntrag, { state: { id: get(res, 'data.id'), api: APIS.Abschlussbericht } });
		} catch (err: any) {
			console.error('ERROR: Creating Abschlussbericht ', err);
		} finally {
			setLoading(false);
		}
	};

	const RenderMittelabrufButtons: FC<{}> = () => {
		// autofold/fold_next
		const buttons: ReactElement[] = [];

		// Group Mittelabruf by Haushaltsjahr (project year)
		const groupedMittelabrufNachProjektJahr = mittelAbruf.reduce((acc: any, item: any) => {
			const year = item.attributes.Allgemein_Haushaltsjahr;
			if (!acc[year]) {
				acc[year] = [];
			}
			acc[year].push(item);
			return acc;
		}, {});

		// Loop through each year of the project duration
		for (let i = 0; i < projektDauer; i++) {
			const currentProjektJahr = projektJahrStart + i; // Determine current year

			// Check if there's any Mittelabruf for the current year
			const mittelabrufForYear = groupedMittelabrufNachProjektJahr[currentProjektJahr];

			// Determine whether the button to create Mittelabruf for this year should be enabled
			const isYearValidForCreation = checkJahrCondition ? currentProjektJahr === currentYear : true;

			// If there are Mittelabruf(s) for the year, show them
			if (mittelabrufForYear && mittelabrufForYear.length > 0) {
				// Checking if the last mittelabruf has the status "freigegeben"
				const isLastMittelFrei =
					(
						get(mittelabrufForYear[mittelabrufForYear.length - 1], MA_P.Mittelabrufstatus_Mittelabrufstatus.path, '') ===
							ANTRAGS_STATUS.freigegeben ||
						get(mittelabrufForYear[mittelabrufForYear.length - 1], MA_P.Mittelabrufstatus_Mittelabrufstatus.path, '') === ANTRAGS_STATUS.abgelehnt
					) ?
						true
					:	false;
				let isMAErstellenButtonDisabled: boolean = false;
				if (isLastMittelFrei) {
					if (isMAErstellenButtonDisabled) {
						// if last mittelabruf is "freigegeben" but the current year is not valid then no MA can be created
						isMAErstellenButtonDisabled = true;
					} else {
						isMAErstellenButtonDisabled = false;
					}
				} else {
					// Disable the create button, if last MA for this year does not has the status "freigegeben"
					isMAErstellenButtonDisabled = true;
				}
				buttons.push(
					<AntragsButtonWrapper key={currentProjektJahr} title={'Mittelabruf für ' + currentProjektJahr}>
						{mittelabrufForYear.map((eachMA: any, index: number) => {
							return (
								<AntragButton
									key={`mittelabruf-${currentProjektJahr}-${index}`}
									name={`Projektjahr: ${get(eachMA, MA_P.Allgemein_Haushaltsjahr.path)} #${index + 1}`}
									description={enumT(get(eachMA, MA_P.Mittelabrufstatus_Mittelabrufstatus.path))}
									onClick={() =>
										navigate(PAGES_URLS.OnlineAntrag, {
											state: {
												id: get(eachMA, 'id'),
												api: APIS.Mittelabruf,
											},
										})
									}
								/>
							);
						})}

						<MUIToolTip
							title='Sie können neuen Mittelabruf für das Jahr erstellen, sobald die vorherige Mittelabruf freigegeben ist'
							showTootip={isMAErstellenButtonDisabled}
						>
							<AntragButton
								name='Mittelabruf erstellen'
								description=''
								onClick={() => handleCreateMittelabruf(currentProjektJahr)}
								variant={'contained'}
								disabled={isMAErstellenButtonDisabled}
							/>
						</MUIToolTip>
					</AntragsButtonWrapper>
				);
			} else {
				// If there are no Mittelabruf for the year, show the button to create a new one for a new year
				if (get(application, P.Antragstatus_Antragstatus.path) === ANTRAGS_STATUS.inFoerderung) {
					buttons.push(
						<AntragsButtonWrapper key={currentProjektJahr} title={'Mittelabruf für ' + currentProjektJahr}>
							<AntragButton
								name='Mittelabruf erstellen'
								description=''
								onClick={() => handleCreateMittelabruf(currentProjektJahr)}
								variant={'contained'}
								disabled={!isYearValidForCreation} // Disable if the year is not valid
							/>
						</AntragsButtonWrapper>
					);
				} else {
					buttons.push(
						<AntragsButtonWrapper key={currentProjektJahr} title={'Mittelabruf für ' + currentProjektJahr}>
							<AntragButton name={NOCH_NICHT_MOEGLICH_TEXT} description='offen' onClick={() => {}} disabled={true} />
						</AntragsButtonWrapper>
					);
				}
			}
		}

		return <>{buttons}</>;
	};
	const RenderVerwendungsnachweisButtons: FC<{}> = () => {
		// autofold/fold_next
		const buttons: ReactElement[] = [];
		// Group Mittelabruf by Haushaltsjahr (project year)
		const groupedVerwendungsnachweisNachProjektJahr = verwendungsnachweis.reduce((acc: any, item: any) => {
			const year = get(item, VN_P.Allgemein_Haushaltsjahr.path);
			if (!acc[year]) {
				acc[year] = [];
			}
			acc[year].push(item);
			return acc;
		}, {});

		// Loop through each year of the project duration
		for (let i = 0; i < projektDauer; i++) {
			const currentYear = projektJahrStart + i; // Determine current year

			// Check if there's any Mittelabruf for the current year
			const verwendungsnachweisForYear = groupedVerwendungsnachweisNachProjektJahr[currentYear];
			// If there are Mittelabruf(s) for the year, show them
			if (verwendungsnachweisForYear && verwendungsnachweisForYear.length > 0) {
				buttons.push(
					<AntragsButtonWrapper key={currentYear} title={'Verwendungsnachweis für ' + currentYear}>
						{verwendungsnachweisForYear.map((eachVN: any, index: number) => {
							return (
								<AntragButton
									key={`vn-${currentYear}-${index}`}
									name={`Projektjahr: ${get(eachVN, VN_P.Allgemein_Haushaltsjahr.path)} #${index + 1}`}
									description={enumT(get(eachVN, VN_P.Verwendungsnachweisstatus_Status.path))}
									onClick={() =>
										navigate(PAGES_URLS.OnlineAntrag, {
											state: {
												id: get(eachVN, `${VN_P.Mittelabruf.path}.id`),
												api: APIS.Mittelabruf,
											},
										})
									}
								/>
							);
						})}
						<MUIToolTip title={MITTEL_ABRUF_ZUERST_ERSTELLEN_TEXT}>
							<AntragButton
								name='Verwendungsnachweis erstellen'
								description=''
								onClick={() => handleCreateMittelabruf(currentYear)}
								disabled={true}
								variant={'contained'}
							/>
						</MUIToolTip>
					</AntragsButtonWrapper>
				);
			} else {
				// If there are no Mittelabruf for the year, show the button to create a new one
				if (get(application, P.Antragstatus_Antragstatus.path) === ANTRAGS_STATUS.inFoerderung && verwendungsnachweis.length === mittelAbruf.length) {
					buttons.push(
						<AntragsButtonWrapper key={currentYear} title={'Verwendungsnachweis für ' + currentYear}>
							<MUIToolTip title={MITTEL_ABRUF_ZUERST_ERSTELLEN_TEXT}>
								<AntragButton
									name='Verwendungsnachweis erstellen'
									description=''
									onClick={() => handleCreateMittelabruf(currentYear)}
									disabled={true}
									variant={'contained'}
								/>
							</MUIToolTip>
						</AntragsButtonWrapper>
					);
				} else {
					buttons.push(
						<AntragsButtonWrapper key={currentYear} title={'Verwendungsnachweis für ' + currentYear}>
							<AntragButton name={NOCH_NICHT_MOEGLICH_TEXT} description='offen' onClick={() => {}} disabled={true} />
						</AntragsButtonWrapper>
					);
				}
			}
		}

		return <>{buttons}</>;
	};
	const RenderAbschlussberichtButton: FC<{}> = () => {
		// autofold/fold_next
		if (isArray(abschlussbericht) && abschlussbericht.length > 0) {
			return (
				<AntragsButtonWrapper title='Abschlussbericht:'>
					{abschlussbericht.map((eachAbschlussbericht: any, i: number) => {
						return (
							<AntragButton
								key={i}
								name='Abschlussbericht'
								description='Ansehen'
								onClick={() =>
									navigate(`${PAGES_URLS.OnlineAntrag}`, {
										state: { id: get(eachAbschlussbericht, 'id'), api: APIS.Abschlussbericht },
									})
								}
							/>
						);
					})}
				</AntragsButtonWrapper>
			);
		} else {
			if (get(application, P.Antragstatus_Antragstatus.path, '') === ANTRAGS_STATUS.ProjektBeendet) {
				return (
					<AntragsButtonWrapper title='Abschlussbericht:'>
						<AntragButton name='Abschlussbericht' description='Abschlussbericht erstellen' onClick={handleCreateAbschlussbericht} variant='text' />
					</AntragsButtonWrapper>
				);
			} else {
				return (
					<AntragsButtonWrapper title='Abschlussbericht:'>
						<AntragButton name={NOCH_NICHT_MOEGLICH_TEXT} description='offen' onClick={() => {}} variant='text' disabled={true} />
					</AntragsButtonWrapper>
				);
			}
		}
	};

	return (
		<>
			<LoadingBackdrop open={loading} />

			<MuiSnackbar showSnackbar={wsError} closeSnackbar={() => setWsError(false)} alertMessage='Etwas ist schief gelaufen' />
			<AntragsButtonWrapper title='Antrag:'>
				<AntragButton
					name={get(application, P.Allgemein_Projekttitel.path) ? get(application, P.Allgemein_Projekttitel.path) : ANTRAG_BUTTON_NAME}
					description={enumT(get(application, P.Antragstatus_Antragstatus.path))}
					onClick={() =>
						navigate(PAGES_URLS.OnlineAntrag, {
							state: {
								id: get(application, 'id'),
								api: APIS.Antrag,
								antragsformular: get(application, P.Allgemein_Antragsformular.path),
							},
						})
					}
				/>
			</AntragsButtonWrapper>

			<Stack direction='row' spacing={2} justifyContent={'space-between'}>
				<span>
					<RenderMittelabrufButtons />
				</span>
				<span>
					<RenderVerwendungsnachweisButtons />
				</span>
			</Stack>
			<RenderAbschlussberichtButton />
		</>
	);
};

export default EbusseFoerderDashboard;
